<template>
    <div @click="$emit('CloseView')" class="w-full h-[150%] fixed top-0 left-0 bg-[#00000063] z-30 backdrop-blur-[2px]">
        </div>
        <div class="flex fixed justify-center top-[20%] bottom-[20%]  left-[10%] right-[10%] items-center  z-40">
            <div class="flex flex-col justify-center  z-40 bg-white w-[800px] text-lg rounded-lg border-[2px] border-[#006A00] relative">
                <div class="pafcpic_header bg-green-800 py-3 px-6">
                    <p class="text-[#ffffff] text-md font-bold">CONSIDERATION REQUEST</p>
                </div>
                <div class="pafcpic_body py-6 px-6">
                    <p class="text-green-800"></p>
                    <table>
                        <tr>
                            <td class="text-sm font-medium text-[#006A00]">Consideration No.</td>
                            <td class="text-sm font-medium pr-11 text-[#006A00]">:</td>
                            <td class="text-sm ">{{ Data.consi_no }}</td>
                        </tr>
                        <tr>
                            <td class="text-sm font-medium text-[#006A00]">Employee</td>
                            <td class="text-sm font-medium pr-11 text-[#0B6014]">:</td>
                            <td class="text-sm ">{{ Data.employee_name }}</td>
                        </tr>
                        <tr>
                            <td class="text-sm font-medium text-[#006A00]">Date Applied</td>
                            <td class="text-sm font-medium">:</td>
                            <td class="text-sm">{{ Data.date_applied }}</td>
                        </tr>
                        <tr>
                            <td class="text-sm font-medium text-[#006A00]">Category</td>
                            <td class="text-sm font-medium">:</td>
                            <td class="text-sm">{{ Data.category }}</td>
                        </tr>
                         <tr>
                            <td class="text-sm font-medium text-[#006A00]">Date</td>
                            <td class="text-sm font-medium">:</td>
                            <td class="text-sm">{{ Data.covered_date }}</td>
                        </tr>
                        <tr>
                            <td class="text-sm font-medium text-[#006A00]">Reason</td>
                            <td class="text-sm font-medium">:</td>
                            <td class="text-sm">{{ Data.reason }}</td>
                        </tr>
                    </table>
                </div>
                <div class="mt-5 py-5 border-[#b6b5b5] border-t border-b px-6">
                    <div class="flex gap-5">
                        <div class="w-full flex flex-col gap-2">
                          <label class="text-sm text-[#6A6A6A] font-semibold">Recommended by:</label>
                            <div v-if="recommendation == null">
                              <p class="text-sm text-[#a5a5a5]">NO SIGNATORY FOUND</p>
                            </div>
                            <div v-else v-for="(recon,index) in recommendation" :key="index" class="">
                              <p class="text-sm font-semibold  " :class="{'text-[#006A00]': recon.status === 'A','text-[#792424]': recon.status == 'D','text-[#b9b9b9]': !recon.status}">{{recon.employee_name}}</p>
                              <label class="text-sm text-[#6A6A6A]">Immediate Superior</label>
                              <div v-if="recon.status == 'D'">
                                <label class="text-xs font-semibold text-[#6A6A6A]">Remarks:</label>
                                <p class="text-sm font-semibold text-[#792424]"> {{recon.remarks}}</p>
                              </div>
                            </div>
                        </div>
                        <div class=" w-full flex flex-col gap-2">
                          
                          <label class="text-sm text-[#6A6A6A] font-semibold">Approved by:</label>
                          <div v-if="approval == null">
                            <p class="text-sm text-[#a5a5a5]">NO SIGNATORY FOUND</p>
                          </div>
                          <div v-else v-for="(approval,index) in approval" :key="index" class="">
                            <div v-if="approval != null">
                                <div class="flex relative w-auto">
                                    <p class="text-sm font-semibold " :class="{'text-[#006A00]': approval.status == 'A','text-[#792424]': approval.status == 'D','text-[#b9b9b9]': !approval.status}">{{approval.employee_name}}</p>
                                    <!-- <img v-if="approval.status == 'A'" src="../../assets/signature.png" class="w-[80px] absolute   left-10 right-0"> -->
                                </div>
                              <label class="text-sm text-[#6A6A6A]">Division / Office Executive</label>
                              <div v-if="approval.status == 'D'">
                                <label class="text-xs font-semibold text-[#6A6A6A]">Remarks:</label>
                                <p class="text-sm font-semibold text-[#792424]"> {{approval.remarks}}</p>
                              </div>
                           
                            </div>
                          </div>
                        </div>
                      </div>
                  </div>
            
            <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#00800048] border-t font-medium">
                <button class="text-sm text-white bg-[#016B00] py-3 px-7 rounded-md " v-if="Data.con_status == 'A' && activeBtn =='Button2' && Data.con_noted_datetime == null" @click="$emit('endorse',Data.consi_no)" >Endorse</button>
                <button class="text-sm text-white bg-[#016B00] py-3 px-7 rounded-md " v-if="Data.con_status == 'A' && activeBtn =='Button3' && Data.con_noted_datetime != null && Data.con_apv_datetime == null" @click="$emit('approve',Data.consi_no)" >Approve</button>
                <!-- <button class="text-sm text-white bg-[#006A00] py-1.5 px-7 rounded-md w-[150px]" v-on:click="$emit('NoteConsi',Data.consi_no)" v-if="Data.con_status === 'A' && activeBtn == 'Button1' ">NOTE</button> -->
                <button class="text-sm text-[#6A6A6A] bg-[#D9D9D9] py-1.5 px-7 rounded-md " @click="$emit('cancel')" >Close</button>
            </div>
        </div>
        </div>

</template>

<script>

import { defineComponent } from "vue";
import Services from '../../../services/admin'

export default defineComponent({
    components: {
       
    },
    data() {
        return {
            consiKey:null,
            signatory: null,
            recommendation:'',
            approval:'',
        }
    },
    props: {
        Data: {
            type: Object,
            default: null,
        },
        Approval:{
            type : Boolean,
            default: false,
        },
        activeBtn:{
            type : String,
            default: null,
        }
    },
    mounted(){
        this.consiKey = this.Data.consi_no
        this.getConsiSignatory()
    },
    methods:{
        async getConsiSignatory(){

            const success       = await Services.consiSignatory(this.consiKey);
            this.signatory        = success.data

            if(this.signatory!=null ){

                this.recommendation = this.signatory.filter(signatory=>signatory.rank == 'R')
                this.approval       = this.signatory.filter(signatory=>signatory.rank == 'A')

                if(this.approval.length == 0){
                    this.approval = null
                }
            }
        },
        
    }
})

</script>